var map = {
	"./de/triangle-icon.png": "6k5g",
	"./en/triangle-icon.png": "3X7Z",
	"./es/triangle-icon.png": "+M8u",
	"./fr/triangle-icon.png": "BWT/",
	"./ja/triangle-icon.png": "5xRQ",
	"./ko/triangle-icon.png": "9FTG",
	"./pt/triangle-icon.png": "IgYe",
	"./ru/triangle-icon.png": "KNof",
	"./tc/triangle-icon.png": "QUgk",
	"./th/triangle-icon.png": "VfZy"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rl1a";